import "./NewButton.scss";

export default function NewButton(props: { text: string; onClick: CallableFunction; }) {
    return (<div className="new-button-container" onClick={() => { props.onClick(); }}>{"+ " + props.text}</div>)
}